import React from "react"
import Blog from './Blog'
import type { BlogPost } from '../data/db/database'

interface BlogViewProps {
  blog: BlogPost[]
}

const BlogView: React.FC<BlogViewProps> = ({ blog }) => {
  return (
    <div className="row mt-30-reverse">
      {blog.map(blog => (
        <div className="col-lg-6 col-md-6 col-12 mt-30" key={blog.id}>
          <Blog data={{ ...blog, id: String(blog.id) }} />
        </div>
      ))}
    </div>
  )
}

export default BlogView
